export const RECENT_CONTACTS_LIMIT = 4;
